const acfformMasterialsSetup = () => {
  const components = document.querySelectorAll('[data-component-acfform-materials]');

  components.forEach((component) => {

  });


};
acfformMasterialsSetup();


jQuery(window).bind("load", function () {
  // Prefill the value of the form field
  $('body.page-template-page-mijn-materialen #acf-_post_title').val('bestelling van materialen');
});